<div class="bid-min-amount-modal-fullscreen" *ngIf="isActive">
  <div class="modal-overlay" (click)="closeModal()"></div>
  <div class="modal-content">
    <button class="close-modal" (click)="closeModal()">&times;</button>

    <div class="modal-inner">
      <div class="modal-header">
        <h2>Minimum bid amount per {{ environment.tokenName }}</h2>
        <p>
          Set a minimum ETH amount per {{ environment.tokenName }} to filter low-value bid notifications.
          Only bids at or above the limit will trigger email/Telegram alerts. Leave empty for no minimum.
        </p>
      </div>

      <div class="modal-loading" *ngIf="loading">
        Loading your {{ environment.tokenName }}s...
      </div>

      <div class="modal-error" *ngIf="error">
        {{ error }}
      </div>

      <ng-container *ngIf="!loading && rows.length === 0 && !error">
        <div class="modal-empty">
          You don't own any {{ environment.tokenName }}s.
        </div>
      </ng-container>

      <ng-container *ngIf="!loading && rows.length > 0">
        <div class="global-controls">
          <div class="global-apply">
            <label>Set all to:</label>
            <input
              type="number"
              class="shared-input"
              [(ngModel)]="globalMinAmount"
              placeholder="ETH"
              min="0"
              step="0.01"
            />
            <button
              class="submit"
              (click)="applyGlobalMinAmount()"
              [class.disabled]="isGlobalAmountEmpty">
              Apply to all
            </button>
          </div>
          <button class="clear-all-btn" (click)="clearAllLimits()">
            Clear all
          </button>
        </div>

        <div class="punk-limits-list">
          <div class="punk-limit-row" *ngFor="let row of rows">
            <img
              [src]="dataSvc.staticUrl + dataSvc.tokenImagePath + (row.punkId | tokenIdParse) + '.svg'"
              width="48"
              height="48"
              [alt]="'Punk ' + row.punkId"
              class="punk-thumb"
            />
            <span class="punk-id">#{{ row.punkId }}</span>
            <div class="punk-limit-input-group">
              <input
                type="number"
                class="shared-input"
                [(ngModel)]="row.minAmountEth"
                placeholder="No min"
                min="0"
                step="0.01"
              />
              <span class="eth-label">ETH</span>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="modal-footer" *ngIf="!loading">
        <button class="cancel-btn" (click)="closeModal()">Cancel</button>
        <button
          class="submit save-btn"
          (click)="save()"
          [class.disabled]="saving || rows.length === 0">
          <span *ngIf="saving">Saving...</span>
          <span *ngIf="!saving">Save</span>
        </button>
      </div>
    </div>
  </div>
</div>
